import { useState } from "react";

import { getRootUrl } from "pstat-anywhere/utils/urls";
import {
  ALL_SELECTED,
  NONE_SELECTED,
  SOME_SELECTED
} from "pstat-design-system/inputs/Checkbox";

export default function useAdvancedReportPage({
  router,
  route,
  location,
  tabs,
  policies,
  initiallySelectedPks,
  isCheckboxDisabled = () => false
}) {
  const [selectedPolicies, setSelectedPolicies] = useState(
    initiallySelectedPks
  );
  let initialSelectAllState = NONE_SELECTED;
  if (initiallySelectedPks.length > 0) {
    initialSelectAllState = SOME_SELECTED;
  }
  const [selectAllCheckboxState, setSelectAllCheckbox] = useState(
    initialSelectAllState
  );
  const selectablePolicies =
    policies && policies.filter(policy => !isCheckboxDisabled(policy));

  function handleTabChange(selectedTab) {
    const tabPath = tabs.filter(tab => tab.id === selectedTab)[0].path;
    if (tabPath) {
      router.push(`${getRootUrl()}/${tabPath}`);
    }
  }

  function handleSortChange(sort) {
    const queryParams = { ...location.query };
    queryParams.sort = sort;
    const to = {
      pathname: location.pathname,
      query: queryParams
    };
    router.push(to);
  }

  function handleCheckboxClick(newPk) {
    //  Don't know what's exactly wrong there, but somehow selectedPolicies
    // becomes stale state. So it will work only this way
    setSelectedPolicies(selectedPolicies => {
      if (selectedPolicies.includes(newPk)) {
        const newSelectedPolicyPks = selectedPolicies.filter(
          pk => pk !== newPk
        );
        if (newSelectedPolicyPks.length === 0) {
          setSelectAllCheckbox(NONE_SELECTED);
        } else {
          setSelectAllCheckbox(SOME_SELECTED);
        }
        return newSelectedPolicyPks;
      } else {
        const newSelectedPolicyPks = [...selectedPolicies, newPk];
        if (newSelectedPolicyPks.length === selectablePolicies.length) {
          setSelectAllCheckbox(ALL_SELECTED);
        } else {
          setSelectAllCheckbox(SOME_SELECTED);
        }
        return newSelectedPolicyPks;
      }
    });
  }

  function handleSelectAll() {
    setSelectedPolicies(policies);
  }

  function handleClearSelection() {
    setSelectedPolicies([]);
  }

  function handleClearSelectionKeyDown(event) {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handleClearSelection();
    }
  }

  function handleSelectAllCheckboxClick() {
    if (selectedPolicies.length === selectablePolicies.length) {
      setSelectedPolicies(policies => []);
      setSelectAllCheckbox(NONE_SELECTED);
    } else {
      setSelectedPolicies(selectablePolicies.map(policy => policy.pk));
      setSelectAllCheckbox(ALL_SELECTED);
    }
  }

  const updatedPolicies =
    policies &&
    policies.map(policy => {
      const policyCopy = { ...policy };
      policyCopy.selected = selectedPolicies.indexOf(policy.pk) > -1;
      return policyCopy;
    });

  return {
    currentRouteName: route?.data?.routeName,
    selectedPolicies,
    selectAllCheckboxState,
    handleSortChange,
    handleTabChange,
    handleCheckboxClick,
    handleClearSelection,
    handleClearSelectionKeyDown,
    handleSelectAll,
    handleSelectAllCheckboxClick,
    updatedPolicies
  };
}
